import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=29a32bcc"
import script from "./VerticalMenu.vue?vue&type=script&lang=ts"
export * from "./VerticalMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports